import { isSafeAuthReturnTo } from './authReturnTo';

const trimTrailingSlash = (value) => String(value || '').trim().replace(/\/+$/, '');

export function isGoogleOAuthEnabled(
  value = process.env.REACT_APP_GOOGLE_OAUTH_ENABLED,
) {
  return String(value || '').trim().toLowerCase() === 'true';
}

export function getGoogleOAuthStartUrl({
  authBaseUrl = process.env.REACT_APP_AUTH_BASE_URL || '',
  returnTo = '',
  fallbackReturnTo = '/playermap',
} = {}) {
  const baseUrl = trimTrailingSlash(authBaseUrl);
  const safeReturnTo = isSafeAuthReturnTo(returnTo)
    ? returnTo
    : isSafeAuthReturnTo(fallbackReturnTo)
    ? fallbackReturnTo
    : '';
  const params = new URLSearchParams();

  if (safeReturnTo) {
    params.set('returnTo', safeReturnTo);
  }

  const query = params.toString();
  return `${baseUrl}/auth/google${query ? `?${query}` : ''}`;
}
